import { Routes, RouterModule, UrlSegment } from '@angular/router';
import { NgModule } from '@angular/core';

import { FeedPageComponent } from './feed-page.component';

export function feedPathMatcher(url: UrlSegment[]) {
  const path = url.join('/');

  if (path.startsWith('feed')) {
    return { consumed: [url[0]] };
  }

  return null;
}

const feedRoutes: Routes = [
  {
    path: 'suggested',
    component: FeedPageComponent,
    data: {
      feedType: 'suggested',
      pageAnalytics: {
        env_template: 'profile_feed',
        pageUrl: '/community/feed/recommended'
      }
    }
  },
  // Default page, match everything, must be at the end of the Routes[]
  {
    path: '**',
    component: FeedPageComponent,
    data: {
      feedType: 'default',
      pageAnalytics: {
        env_template: 'profile_feed',
        pageUrl: '/community/feed/main'
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(feedRoutes)],
  exports: [RouterModule]
})
export class FeedRoutingModule {}
